import React from 'react';
export function CookiesPolicy() {
  return <div className="w-full min-h-screen bg-navy-900" data-id="element-380">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-381">
        {/* Header */}
        <div className="mb-12" data-id="element-382">
          <a href="/" className="inline-flex items-center space-x-1 mb-8 group" data-id="element-383">
            <span className="text-2xl font-display font-bold text-white" data-id="element-384">
              Tru
            </span>
            <span className="text-2xl font-display font-bold text-teal-500" data-id="element-385">
              ID
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-amber-500 group-hover:scale-125 transition-transform" data-id="element-386"></span>
          </a>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-387">
            Política de Cookies
          </h1>
          <div className="h-1 w-20 bg-teal-500 rounded" data-id="element-388"></div>
        </div>

        {/* Content */}
        <div className="prose prose-invert max-w-none space-y-10 text-gray-300 leading-relaxed" data-id="element-389">
          {/* 1. Introducción */}
          <section data-id="element-390">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-391">
              1. INTRODUCCIÓN
            </h2>
            <p data-id="element-392">
              En TruID, utilizamos cookies y tecnologías similares para mejorar
              la experiencia de navegación en nuestros sitios web y plataformas,
              analizar el tráfico, personalizar el contenido y mostrar anuncios
              relevantes. A continuación, te explicamos qué son las cookies,
              cómo las usamos y cómo puedes gestionarlas.
            </p>
          </section>

          {/* 2. ¿Qué son las cookies? */}
          <section data-id="element-393">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-394">
              2. ¿QUÉ SON LAS COOKIES?
            </h2>
            <p data-id="element-395">
              Las cookies son pequeños archivos de texto que un sitio web o
              plataforma almacena en tu dispositivo (computadora, celular,
              Tablet u otro) al visitarlo. Estas permiten que el sitio
              "recuerde" tus acciones o preferencias (como idioma, inicio de
              sesión, etc.) durante un período de tiempo determinado.
            </p>
          </section>

          {/* 3. Tipos de cookies */}
          <section data-id="element-396">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-397">
              3. ¿QUÉ TIPOS DE COOKIES UTILIZAMOS?
            </h2>

            <div className="space-y-6" data-id="element-398">
              <div data-id="element-399">
                <h3 className="text-lg font-semibold text-teal-500 mb-2" data-id="element-400">
                  A. Cookies necesarias (técnicas):
                </h3>
                <p data-id="element-401">
                  Permiten la navegación en el sitio web y el uso de sus
                  funciones esenciales. Sin estas cookies, el sitio no puede
                  funcionar correctamente.
                </p>
              </div>

              <div data-id="element-402">
                <h3 className="text-lg font-semibold text-teal-500 mb-2" data-id="element-403">
                  B. Cookies de preferencia o personalización:
                </h3>
                <p data-id="element-404">
                  Almacenan información para que el usuario acceda al servicio
                  con características personalizadas, como el idioma o región.
                </p>
              </div>

              <div data-id="element-405">
                <h3 className="text-lg font-semibold text-teal-500 mb-2" data-id="element-406">
                  C. Cookies de análisis o rendimiento:
                </h3>
                <p data-id="element-407">
                  Nos permiten conocer el comportamiento de los visitantes para
                  mejorar el sitio. Usamos herramientas como Google Analytics u
                  otras similares.
                </p>
              </div>

              <div data-id="element-408">
                <h3 className="text-lg font-semibold text-teal-500 mb-2" data-id="element-409">
                  D. Cookies de publicidad o marketing:
                </h3>
                <p data-id="element-410">
                  Recopilan información sobre tus hábitos de navegación para
                  mostrarte anuncios relevantes en nuestros sitios o en otros.
                </p>
              </div>
            </div>
          </section>

          {/* 4. Duración */}
          <section data-id="element-411">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-412">
              4. ¿CUÁNTO TIEMPO PERMANECEN ACTIVAS?
            </h2>
            <ul className="list-disc list-inside space-y-2" data-id="element-413">
              <li data-id="element-414">
                <span className="text-white font-medium" data-id="element-415">
                  Cookies de sesión:
                </span>{' '}
                se eliminan al cerrar el navegador.
              </li>
              <li data-id="element-416">
                <span className="text-white font-medium" data-id="element-417">
                  Cookies persistentes:
                </span>{' '}
                permanecen en tu dispositivo hasta que las elimines o expiren.
              </li>
            </ul>
          </section>

          {/* 5. Control */}
          <section data-id="element-418">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-419">
              5. ¿CÓMO PUEDES CONTROLAR LAS COOKIES?
            </h2>
            <p className="mb-4" data-id="element-420">
              Al ingresar por primera vez a nuestro sitio, se te mostrará un
              aviso de cookies. Puedes aceptar todas, rechazarlas o
              configurarlas según tu preferencia.
            </p>
            <p className="mb-4" data-id="element-421">
              Además, puedes modificar la configuración de cookies desde tu
              navegador en cualquier momento:
            </p>
            <ul className="list-disc list-inside space-y-2" data-id="element-422">
              <li data-id="element-423">
                <span className="text-white font-medium" data-id="element-424">Google Chrome:</span>{' '}
                Configuración de cookies
              </li>
              <li data-id="element-425">
                <span className="text-white font-medium" data-id="element-426">Mozilla Firefox:</span>{' '}
                Administrar cookies
              </li>
              <li data-id="element-427">
                <span className="text-white font-medium" data-id="element-428">Safari:</span> Soporte
                de Safari
              </li>
              <li data-id="element-429">
                <span className="text-white font-medium" data-id="element-430">Microsoft Edge:</span>{' '}
                Privacidad y servicios
              </li>
            </ul>
          </section>

          {/* 6. Cookies de terceros */}
          <section data-id="element-431">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-432">
              6. COOKIES DE TERCEROS
            </h2>
            <p className="mb-4" data-id="element-433">
              Algunas cookies pueden ser instaladas por servicios de terceros
              utilizados en nuestro sitio (como redes sociales, plataformas de
              video, servicios de estadísticas, etc.). No tenemos control
              directo sobre ellas. Te recomendamos revisar sus respectivas
              políticas:
            </p>
            <ul className="list-disc list-inside space-y-2" data-id="element-434">
              <li data-id="element-435">
                <span className="text-white font-medium" data-id="element-436">Google:</span> Política
                de privacidad
              </li>
              <li data-id="element-437">
                <span className="text-white font-medium" data-id="element-438">
                  Meta (Facebook / Instagram):
                </span>{' '}
                Política de cookies
              </li>
            </ul>
          </section>

          {/* 7. Cambios */}
          <section data-id="element-439">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-440">
              7. CAMBIOS EN ESTA POLÍTICA
            </h2>
            <p data-id="element-441">
              Podemos actualizar esta Política de Cookies en cualquier momento.
              Te notificaremos en nuestro sitio web cuando se hagan cambios
              relevantes.
            </p>
          </section>

          {/* 8. Contacto */}
          <section data-id="element-442">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-443">
              8. CONTACTO
            </h2>
            <p data-id="element-444">
              Si tienes dudas sobre nuestra política de cookies, puedes
              escribirnos a:
            </p>
            <p className="mt-2" data-id="element-445">
              <a href="mailto:protecciondatos@truid.org" className="text-teal-500 hover:text-teal-400 transition-colors font-medium" data-id="element-446">
                protecciondatos@truid.org
              </a>
            </p>
          </section>

          {/* 9. Vigencia */}
          <section data-id="element-447">
            <h2 className="text-xl font-display font-semibold text-white mb-4" data-id="element-448">
              9. VIGENCIA
            </h2>
            <p data-id="element-449">
              La vigencia de estas Políticas es desde el 21 de noviembre de 2025
              y permanecerá vigente hasta que exista una nueva versión que la
              reemplace.
            </p>
          </section>
        </div>
      </div>
    </div>;
}